import { createAsyncThunk } from '@reduxjs/toolkit';
import { PropertyApi } from '../../api/PropertyApi';
import { RecordLimit } from '../../data/Constants';

import type {
  IAuthorizationRequest,
  IPaginationRequest,
  IPropertyAssociationRequest,
  ISearchRequest,
  IUpdateRequest,
  IPropertiesRequest,
} from '../../../types/IApiTypes';

//Property thunks
//To get the paginated property data
export const getProperties = createAsyncThunk(
  'property/getProperties',
  async (action: IPropertiesRequest, thunkAPI) => {
    return PropertyApi.getProperties(action, thunkAPI.dispatch);
  }
);

//To get a property details
export const getPropertyDetails = createAsyncThunk(
  'property/getPropertyDetails',
  async (action: ISearchRequest, thunkAPI) => {
    return PropertyApi.getPropertyDetails(action, thunkAPI.dispatch);
  }
);

//to update a property
export const updateProperty = createAsyncThunk(
  'property/updateProperty',
  async (action: IUpdateRequest, thunkAPI) => {
    return PropertyApi.updateProperty(action, thunkAPI.dispatch);
  }
);

//To create a property
export const createProperty = createAsyncThunk(
  'property/createProperty',
  async (action: IUpdateRequest, thunkAPI) => {
    return PropertyApi.createProperty(action, thunkAPI.dispatch);
  }
);

//To delete a property
export const deleteProperty = createAsyncThunk(
  'property/deleteProperty',
  async (action: IUpdateRequest, thunkAPI) => {
    return PropertyApi.deleteProperty(action, thunkAPI.dispatch);
  }
);

//To get paginated property associations
export const getPropertyAssociations = createAsyncThunk(
  'property/getPropertyAssociations',
  async (action: IPaginationRequest, thunkAPI) => {
    return PropertyApi.getPropertyAssociations(action, thunkAPI.dispatch);
  }
);

//To get paginated feature property associations
export const getFeaturePropertyAssociations = createAsyncThunk(
  'property/getFeaturePropertyAssociations',
  async (action: IPropertyAssociationRequest, thunkAPI) => {
    return PropertyApi.getFeaturePropertyAssociations(action, thunkAPI.dispatch);
  }
);

//Read all properties to show on Property associations tab
export const getAllProperties = createAsyncThunk(
  'property/getAllProperties',
  async (action: IAuthorizationRequest, thunkAPI) => {
    return PropertyApi.getProperties(
      {
        token: action.token,
        page: 1,
        limit: RecordLimit.default,
        searchCode: '',
      },
      thunkAPI.dispatch
    );
  }
);

//To Get list of values for a Enum type properties
export const getEnumListOfValues = createAsyncThunk(
  'dataMaintenance/getEnumListOfValues',
  async (_action, thunkAPI) => {
    return PropertyApi.getEnumListOfValues(thunkAPI.dispatch);
  }
);
